'use client'

import { ChevronUp } from 'lucide-react'
import { useEffect, useState } from 'react'

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300)
    }

    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  if (!visible) return null

  return (
    <button
      onClick={scrollToTop}
      className='bg-mountain-bluebird hover:bg-mountain-bluebird/50 fixed right-6 bottom-6 z-50 cursor-pointer rounded-full p-3 text-white shadow-lg transition'
      aria-label='Scroll to top'
    >
      <ChevronUp />
    </button>
  )
}
